const TEST_KEY = "__storage_test__"

const tryStorage = (storage: Storage): Nullable<Storage> => {
  try {
    storage.setItem(TEST_KEY, "test")
    storage.removeItem(TEST_KEY)
    return storage
  } catch {
    return null
  }
}

const localStorage = tryStorage(window.localStorage)
const sessionStorage = tryStorage(window.sessionStorage)

export { localStorage, sessionStorage }
